(function () {
  var instances = new WeakMap();

  var getCardsPerRow = function (section) {
    var cardsPerRow = parseInt(section.dataset.cardsPerRow, 10);

    if (!cardsPerRow || cardsPerRow < 1) {
      cardsPerRow = parseInt(section.style.getPropertyValue('--custom-feature-cards-cards-per-row'), 10);
    }

    return cardsPerRow > 0 ? cardsPerRow : 3;
  };

  var getBlocksCount = function (section) {
    return parseInt(section.dataset.blocksCount, 10) || 0;
  };

  var getSlidesPerGroup = function (swiper) {
    if (!swiper || !swiper.params) {
      return 1;
    }

    return swiper.params.slidesPerGroup || 1;
  };

  var getPageCount = function (section, swiper) {
    var blocksCount = getBlocksCount(section);
    var slidesPerGroup = getSlidesPerGroup(swiper);

    if (!blocksCount) {
      return 0;
    }

    return Math.max(1, Math.ceil(blocksCount / slidesPerGroup));
  };

  var getCurrentPage = function (section, swiper) {
    var blocksCount = getBlocksCount(section);

    if (!blocksCount) {
      return 0;
    }

    var slidesPerGroup = getSlidesPerGroup(swiper);
    var realIndex =
      swiper && swiper.params && swiper.params.loop && typeof swiper.realIndex === 'number'
        ? swiper.realIndex
        : swiper && typeof swiper.activeIndex === 'number'
          ? swiper.activeIndex
          : 0;

    return Math.min(Math.floor(realIndex / slidesPerGroup) + 1, getPageCount(section, swiper));
  };

  var updateControlsVisibility = function (section) {
    var carousel = section.querySelector('.custom-feature-cards-carousel__carousel');

    if (!carousel) {
      return;
    }

    var blocksCount = parseInt(section.dataset.blocksCount, 10) || 0;
    var cardsPerRow = getCardsPerRow(section);
    var hideOnDesktop =
      window.matchMedia('(min-width: 960px)').matches && blocksCount > 0 && blocksCount <= cardsPerRow;

    carousel.classList.toggle('custom-feature-cards-carousel__carousel--controls-hidden', hideOnDesktop);
  };

  var updatePagination = function (section, swiper) {
    var paginationEl = section.querySelector('.custom-feature-cards-carousel__pagination');

    if (!paginationEl || !swiper) {
      return;
    }

    var totalPages = getPageCount(section, swiper);
    var currentPage = getCurrentPage(section, swiper);

    paginationEl.textContent = totalPages ? currentPage + '/' + totalPages : '';
  };

  var initCarousel = function (section) {
    var swiperEl = section.querySelector('.custom-feature-cards-carousel__swiper');

    if (!swiperEl || !window.Swiper || swiperEl.swiper) {
      return;
    }

    var cardsPerRow = getCardsPerRow(section);
    var blocksCount = getBlocksCount(section);
    var enableLoop = blocksCount > 1;
    var paginationEl = section.querySelector('.custom-feature-cards-carousel__pagination');
    var prevEl = section.querySelector('.custom-feature-cards-carousel__nav--prev');
    var nextEl = section.querySelector('.custom-feature-cards-carousel__nav--next');

    var swiper = new Swiper(swiperEl, {
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 16,
      speed: 600,
      loop: enableLoop,
      loopAddBlankSlides: true,
      watchOverflow: true,
      watchSlidesProgress: true,
      simulateTouch: true,
      grabCursor: true,
      preventClicks: true,
      preventClicksPropagation: true,
      breakpoints: {
        960: {
          slidesPerView: cardsPerRow,
          slidesPerGroup: 1,
          spaceBetween: 24,
        },
      },
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      pagination: paginationEl
        ? {
            el: paginationEl,
            type: 'custom',
            renderCustom: function () {
              return '';
            },
          }
        : undefined,
      on: {
        init: function () {
          section.querySelectorAll('.custom-feature-cards-carousel__card-image').forEach(function (img) {
            img.setAttribute('draggable', 'false');
          });

          updateControlsVisibility(section);
          updatePagination(section, this);
        },
        slideChange: function () {
          updatePagination(section, this);
        },
        resize: function () {
          updateControlsVisibility(section);
          updatePagination(section, this);
        },
        breakpoint: function () {
          updateControlsVisibility(section);
          updatePagination(section, this);
        },
        lock: function () {
          updateControlsVisibility(section);
          updatePagination(section, this);
        },
        unlock: function () {
          updateControlsVisibility(section);
          updatePagination(section, this);
        },
      },
    });

    var onResize = function () {
      var instance = instances.get(section);

      if (!instance || !instance.swiper || instance.swiper.destroyed) {
        return;
      }

      updateControlsVisibility(section);
      updatePagination(section, instance.swiper);
    };

    window.addEventListener('resize', onResize);

    instances.set(section, {
      swiper: swiper,
      onResize: onResize,
    });

    updateControlsVisibility(section);
    updatePagination(section, swiper);

    return swiper;
  };

  var destroyCarousel = function (section) {
    var instance = instances.get(section);

    if (!instance) {
      return;
    }

    if (instance.onResize) {
      window.removeEventListener('resize', instance.onResize);
    }

    if (instance.swiper && !instance.swiper.destroyed) {
      instance.swiper.destroy(true, true);
    }

    instances.delete(section);
  };

  var initSections = function (root) {
    var scope = root || document;

    scope.querySelectorAll('[data-custom-feature-cards-carousel]').forEach(function (section) {
      initCarousel(section);
    });
  };

  var destroySections = function (root) {
    var scope = root || document;

    scope.querySelectorAll('[data-custom-feature-cards-carousel]').forEach(function (section) {
      destroyCarousel(section);
    });
  };

  var bootstrap = function () {
    initSections();

    if (window.Swiper) {
      return;
    }

    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;

      if (window.Swiper) {
        window.clearInterval(timer);
        initSections();
      } else if (attempts > 50) {
        window.clearInterval(timer);
      }
    }, 100);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initSections(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroySections(event.target);
  });
})();
